import { AssistantValue } from "../../../../services/api/instances/assistantsApi/types";
import { CasesValue } from "../../../../services/api/instances/casesApi/types";
import { EditorValue } from "../../../../services/api/instances/editorApi/types";
import { StorageObjectValue } from "../../../../services/api/instances/storageApi/types/service_types";

export const isServiceAssistantValue = (
  value: StorageObjectValue,
): value is AssistantValue => {
  return (value as AssistantValue).assistant_object !== undefined;
};

export const isServiceCasesValue = (
  value: StorageObjectValue,
): value is CasesValue => {
  return (value as CasesValue).case_object !== undefined;
};

export const isServiceSpaValue = (
  value: StorageObjectValue,
): value is EditorValue => {
  return (value as EditorValue).spa_object !== undefined;
};
